import React, { Component, Fragment, Text } from "react";
import Styles from "components/Calculators/styles/styles";

class AccessDenied extends Component {
  render() {
    return <Styles>
      <div className="dialogInner_PersonalSettings">
        <header>You do not have permissions to view this page.</header>
        <header>Please contact your LoanBoss Administrator if you think you've received this error by mistake.</header>
      </div>
    </Styles>;
  }
}

export default AccessDenied;
